import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

/** import all components */
import Login from "./components/Login";
import LandingPage from "./components/LandingPage";
import Password from "./components/Password";
import Register from "./components/Register";
import Profile from "./components/Profile";
import Recovery from "./components/Recovery";
import Reset from "./components/Reset";
import Booking from "./components/Booking";
import Dashboard from "./components/Dashboard";
import PageNotFound from "./components/PageNotFound";
import Sizeup from "./components/Sizeup";
import Freeresetguide from "./components/Freeresetguide";
import Breathing from "./components/Breathing";
import Focus from "./components/Focus";
import Healing from "./components/Healing";


/** auth middleware */
import { AuthorizeUser, ProtectRoute } from "./middleware/auth";

/** layout */
import AuthLayout from "./components/AuthLayout";

/** root routes */
const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/password",
    element: (
      <ProtectRoute>
        <Password />
      </ProtectRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <AuthorizeUser>
        <AuthLayout>
          <Profile />
        </AuthLayout>
      </AuthorizeUser>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <AuthorizeUser>
        <AuthLayout>
          <Dashboard />
        </AuthLayout>
      </AuthorizeUser>
    ),
  },
  {
    path: "/booking",
    element: (
      <AuthorizeUser>
        <AuthLayout>
          <Booking />
        </AuthLayout>
      </AuthorizeUser>
    ),
  },
  {
    path: "/recovery",
    element: <Recovery />,
  },
  {
    path: "/Sizeup",
    element: (
      <AuthorizeUser>
        <AuthLayout>
          <Sizeup />
        </AuthLayout>
      </AuthorizeUser>
    ),
  },
  {
    path: "/reset",
    element: <Reset />,
  },
  {
    path: "/Freeresetguide",
    element: <Freeresetguide />,
  },

  {
    path: "/meditation/breathing",
    element: (
      <AuthorizeUser>
        <AuthLayout>
          <Breathing />
        </AuthLayout>
      </AuthorizeUser>
    ),
  },

  {
    path: "*",
    element: <PageNotFound />,
  },

{
  path: "/meditation/focus",
  element: (
    <AuthorizeUser>
      <AuthLayout>
        <Focus />
      </AuthLayout>
    </AuthorizeUser>
  ),
},
{
  path: "/meditation/healing",
  element: (
    <AuthorizeUser>
      <AuthLayout>
        <Healing />
      </AuthLayout>
    </AuthorizeUser>
  ),
},
]);


export default function App() {
  return (
    <main>
      <RouterProvider router={router} />
    </main>
  );
}

